
export class GiftCardRequestDto {
    number: string;
    email: string;
  }
  